/**
 * UPT-2079 L6c (web §5.6) — le courriel de l'utilisateur courant, lu dans le contexte d'authentification déjà chargé (`auth_context_store`, comme
 * `useEntityPermissions`). Il sert UNIQUEMENT à dire « une autre personne doit approuver cette copie » quand l'utilisateur est celui qui l'a demandée :
 * c'est une commodité d'affichage, le serveur reste le juge (409 `pipeline.approval.self`). Contexte absent (chargement, tests) : `null`, l'écran offre alors
 * « Approuver la copie » et le serveur tranche. Rien n'est écrit ni envoyé : le courriel n'est jamais stocké dans le navigateur ni transmis.
 */
import { useEffect, useState } from 'react';
import { getAuthContextState, subscribeAuthContextState } from '@/uptk/core/api/auth_context_store';
import type { AuthContextResponse } from '@/types/auth_context';

const emailOf = (context: AuthContextResponse | null | undefined): string | null => {
  const email = context?.email;
  return typeof email === 'string' && email.trim() !== '' ? email : null;
};

export function useCurrentUserEmail(): string | null {
  const [email, setEmail] = useState<string | null>(() => emailOf(getAuthContextState()));
  useEffect(() => {
    // Le contexte a pu changer entre le rendu et l'abonnement.
    setEmail(emailOf(getAuthContextState()));
    return subscribeAuthContextState((context) => setEmail(emailOf(context)));
  }, []);
  return email;
}

export default useCurrentUserEmail;
